import React from 'react';
import AdminDashboard from './AdminDashboard';

export default function AdminPanel() {
  return <AdminDashboard />;
}
